import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f2f4e5b6"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-download-14px" }, null, -1));
import { computed } from 'vue';
import moment from 'moment';
import FileDownload from 'js-file-download';
import bus from '@/helpers/events/bus';
import { exportDataIngestionHistory } from '@/features/DataIngestionHistory/services';
import { dateFormat } from '@/utilities/constants';
import { useStore } from 'vuex';
import { useMixpanelDataIngestionHistoryExport } from '@/utilities/mixpanel/dataIngestionHistory';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataIngestionHistoryExportButton',
    props: {
        date: {},
        status: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const selectedBrand = computed(() => store.state.auth.selectedBrand?.brand);
        const fetchExportData = (fileType) => {
            const featureName = 'Ingestão de Dados';
            bus.$emit('render-page-loader', true);
            exportDataIngestionHistory(props.date, fileType, 'blob')
                .then(response => {
                const date = moment().format(dateFormat);
                const fileName = `${featureName} - ${selectedBrand.value} - ${props.date} exportado em ${date}.${fileType}`;
                useMixpanelDataIngestionHistoryExport('view_integrations_data-ingestion-history_export', date, fileName, props.status);
                FileDownload(response, fileName);
            })
                .finally(() => {
                bus.$emit('render-page-loader', false);
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: "btn data-ingestion-history__btn-export",
                "data-cy": "data-ingestion-history-btn-export",
                onClick: _cache[0] || (_cache[0] = ($event) => (fetchExportData('csv')))
            }, [
                _hoisted_1,
                _createTextVNode(" Exportar ")
            ]));
        };
    }
});
